export default function clearCards(
  setPlayer: any,
  setRiver: any,
  setDealer: any,
  handleDealOut: any,
  handleCardDeal: any,
  setFlipCard: any,
  setDealRiver: any,
  delay: number | 0,
) {
  setTimeout(() => {
    setPlayer(['X0', 'X0'])
    setRiver(['X0', 'X0', 'X0', 'X0', 'X0'])
    setDealer(['X0', 'X0'])
    handleDealOut(false)
    handleCardDeal(false)
    setFlipCard(false)
    setDealRiver(false)
  }, delay)
}
